import { useCustomizations } from '@client/new/hooks/use-customizations';

// Permission-style hook: collapses loading to false so swap curation UI
// stays hidden until the flag is confirmed on. The id is always passed
// through - useCustomizations falls back to the logged-in user's own flag
// when given nothing, which would read the wrong creator for staff.
export const useIsCreatorApprovedSwapsEnabled = (
  influencerId: number,
): boolean => {
  const { customizations } = useCustomizations(String(influencerId));

  return customizations?.isCreatorApprovedSwapsEnabled === true;
};
